import React from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog, Classes, AnchorButton, Intent } from '@blueprintjs/core'

const BPDialog = React.memo(({
  title, children, onClose, show, size, onAccept, Icon, isCloseButtonShown = true, showChange = true,
  canOutsideClickClose, canEscapeKeyClose, ...rest
}) => {
  const { t } = useTranslation()

  const handleOnClose = () => {
    onClose && onClose()
  }

  const handleOnAccept = () => {
    onAccept && onAccept()
  }

  return (
    <>
      {show &&
        <Dialog
          className={`${size ? 'bp3-dialog-' + size : ''} bluePrintDialog thin-scroolbar`}
          isOpen={show}
          title={title}
          icon={Icon || <img src='img/logo/ROCHE_LOGO_22px_RGB_DIGITAL.png' alt='Roche Logo' />}
          onAccept={handleOnAccept}
          onClose={handleOnClose}
          isCloseButtonShown={isCloseButtonShown}
          canOutsideClickClose={!!canOutsideClickClose}
          canEscapeKeyClose={!!canEscapeKeyClose}
          lazy     
        >
          <div className={Classes.DIALOG_BODY}>
            {children}
          </div>
          <DialogFooter {...rest} showChange={showChange} t={t} handleOnAccept={handleOnAccept} handleOnClose={handleOnClose} />
        </Dialog>}
    </>
  )
})
const DialogFooter = React.memo(({ t, showChange, handleOnAccept, onLeftAccept, onLeftClose, acceptButtonIcon, confirmButtonText, hideFooterCloseButton, closeButtonIcon, closeButtonIntent, handleOnClose, closeButtonText, removeFooter, footer, leftBottomTemplate, leftCloseButtonText, leftCloseButtonIntent, leftAcceptButtonIcon, leftCloseButtonIcon, leftAcceptButtonText }) => {
  const handleOnLeftAccept = () => {
    onLeftAccept && onLeftAccept()
  }

  const handleOnLeftClose = () => {
    onLeftClose && onLeftClose()
  }

  return (
    !removeFooter && (footer ||
      <>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <div style={{ marginRight: 'auto' }}>
              {leftBottomTemplate || (
                <div>
                  {leftCloseButtonText && <AnchorButton intent={leftCloseButtonIntent || Intent.DANGER} icon={leftCloseButtonIcon} onClick={handleOnLeftClose}>{leftCloseButtonText || t('close')}</AnchorButton>}
                  {leftAcceptButtonText && <AnchorButton intent={Intent.SUCCESS} icon={leftAcceptButtonIcon} onClick={handleOnLeftAccept}>{leftAcceptButtonText || t('save_changes')}</AnchorButton>}
                </div>
              )}

            </div>
            <div style={{ marginLeft: 'auto', marginTop: 'auto', marginBottom: 'auto' }}>
              {!hideFooterCloseButton &&
                <AnchorButton icon={closeButtonIcon} intent={closeButtonIntent || Intent.DANGER} onClick={handleOnClose}>{closeButtonText || t('close')}</AnchorButton>}
              {showChange &&
                <AnchorButton
                  intent={Intent.PRIMARY}
                  onClick={handleOnAccept}
                  icon={acceptButtonIcon}
                >
                  {confirmButtonText || t('save_changes')}
                </AnchorButton>}
            </div>
          </div>
        </div>
      </>)
  )
})

export default BPDialog

// Dialog sizes = 50,60,90 %
